import request from "@/utils/request";


const obj = {
    agentGetMonthlyRecord(params) {
        return request.get(
            `/device/memberMonthlyLog/agentGetMonthlyRecord`,{
                params
            }
        )
    }

};
export default obj;
